export default __webpack_public_path__ + "static/open-telemetry-87a894fb34a381df677f34a8803862c8.svg";